(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function bindOnce(el, key, fn) {
    if (!el) return false;
    const attr = `data-bound-${key}`;
    if (el.getAttribute(attr) === "1") return false;
    el.setAttribute(attr, "1");
    fn();
    return true;
  }

  function getQtyInput(root) {
    return qs(root, '[id^="quantityInput-"]') || qs(root, '#quantityInput');
  }

  function initProductDisplayTop(root = document) {
    const tiles = qsa(root, ".buy-more-tile");
    const qtyInput = getQtyInput(root);

    function updateAddToCartPriceFromTile(tile) {
      const rawPrice = tile ? qs(tile, ".buy-more-price") : null;
      const addBtn = qs(root, "#main-add-to-cart-button") || qs(root, ".product-form__add-button");
      if (!rawPrice || !addBtn) return;
      const mainPriceOnly = (rawPrice.childNodes[0]?.textContent || "").trim();
      if (!mainPriceOnly) return;
      addBtn.textContent = `Add to cart – ${mainPriceOnly}`;
    }

    function handleQtyChange(qty) {
      if (!qtyInput) return;
      qtyInput.value = qty;
      let matchedTile = null;
      tiles.forEach(t => {
        const tileQty = parseInt(t.getAttribute("data-qty"), 10);
        if (tileQty === qty) matchedTile = t;
      });
      if (matchedTile) {
        tiles.forEach(t => t.classList.remove("selected"));
        matchedTile.classList.add("selected");
        updateAddToCartPriceFromTile(matchedTile);
      }
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    window.updateQty = function updateQty(delta, inputId) {
      const input = (inputId && document.getElementById(inputId)) || getQtyInput(root) || qtyInput;
      if (!input) return;
      const min = parseInt(input.getAttribute("min") || "1", 10);
      const current = parseInt(input.value || String(min), 10);
      const next = Math.max(min, (isNaN(current) ? min : current) + delta);
      handleQtyChange(next);
    };

    tiles.forEach(tile => {
      bindOnce(tile, "tile", () => {
        tile.addEventListener("click", () => {
          if (!qtyInput) return;
          const tileQty = parseInt(tile.getAttribute("data-qty"), 10);
          if (!isNaN(tileQty)) handleQtyChange(tileQty);
        });
      });
    });

    if (qtyInput) {
      const defaultTile = qs(root, '.buy-more-tile[data-qty="1"]');
      if (defaultTile) {
        defaultTile.classList.add("selected");
        qtyInput.value = 1;
        updateAddToCartPriceFromTile(defaultTile);
      }
      bindOnce(qtyInput, "qtyinput", () => {
        qtyInput.addEventListener("change", () => {
          const qty = parseInt(qtyInput.value, 10);
          handleQtyChange(isNaN(qty) ? 1 : Math.max(1, qty));
        });
      });
    }

    qsa(root, ".upsell-add-button").forEach((button) => {
      bindOnce(button, "upsell", () => {
        button.addEventListener("click", async () => {
          const variantId = button.getAttribute("data-variant-id");
          if (!variantId) return;
          const originalText = button.textContent;
          button.textContent = "Adding...";
          button.disabled = true;
          try {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
            if (!res.ok) throw new Error("Add failed");
            await res.json();
            button.textContent = "Added!";
            setTimeout(() => { button.textContent = originalText; button.disabled = false; }, 1200);
            window.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
          } catch (e) {
            console.error(e);
            button.textContent = "Error!";
            setTimeout(() => { button.textContent = originalText; button.disabled = false; }, 1400);
          }
        });
      });
    });

    const addToCartForm = qs(root, 'form[action="/cart/add"]');
    const addToCartButton = qs(root, "#main-add-to-cart-button");
    const quantityInput = getQtyInput(root);
    const variantInput = addToCartForm ? qs(addToCartForm, '[name="id"]') : null;

    if (addToCartForm && addToCartButton && variantInput) {
      bindOnce(addToCartForm, "mainatc", () => {
        addToCartForm.addEventListener("submit", async (e) => {
          e.preventDefault();
          const variantId = variantInput.value;
          const qty = parseInt(quantityInput?.value || "1", 10) || 1;
          const originalHTML = addToCartButton.innerHTML;
          addToCartButton.innerHTML = "Adding...";
          addToCartButton.disabled = true;
          try {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: qty }),
            });
            if (!res.ok) throw new Error("Add failed");
            await res.json();
            addToCartButton.innerHTML = "Added!";
            setTimeout(() => { addToCartButton.innerHTML = originalHTML; addToCartButton.disabled = false; }, 1200);
            window.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
          } catch (err) {
            console.error(err);
            addToCartButton.innerHTML = "Error!";
            setTimeout(() => { addToCartButton.innerHTML = originalHTML; addToCartButton.disabled = false; }, 1400);
          }
        });
      });
    }

    qsa(root, ".oloe-accordion .accordion-toggle").forEach((btn) => {
      bindOnce(btn, "accordion", () => {
        btn.addEventListener("click", () => {
          btn.classList.toggle("active");
          const content = btn.nextElementSibling;
          if (!content) return;
          if (content.style.maxHeight && content.style.maxHeight !== "0px") {
            content.style.maxHeight = "0px";
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        });
      });
    });

    const gallery = qs(root, ".carousel-gallery-wrapper.mobile-only .carousel-gallery");
    const thumbs = qsa(root, ".carousel-thumbnails.mobile-only .carousel-thumb");

    if (gallery && thumbs.length) {
      const slides = qsa(gallery, ".carousel-slide");
      function setActiveThumb(index) {
        thumbs.forEach(t => t.classList.remove("active"));
        if (thumbs[index]) thumbs[index].classList.add("active");
      }
      thumbs.forEach((thumb) => {
        bindOnce(thumb, "thumb", () => {
          thumb.addEventListener("click", (e) => {
            e.preventDefault();
            const idx = parseInt(thumb.getAttribute("data-index"), 10);
            if (Number.isNaN(idx) || !slides[idx]) return;
            slides[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
            setActiveThumb(idx);
          });
        });
      });
      bindOnce(gallery, "galleryscroll", () => {
        let raf = null;
        gallery.addEventListener("scroll", () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const gRect = gallery.getBoundingClientRect();
            const gCenter = gRect.left + gRect.width / 2;
            let bestIndex = 0; let bestDist = Infinity;
            slides.forEach((slide, i) => {
              const r = slide.getBoundingClientRect();
              const c = r.left + r.width / 2;
              const d = Math.abs(c - gCenter);
              if (d < bestDist) { bestDist = d; bestIndex = i; }
            });
            setActiveThumb(bestIndex);
          });
        }, { passive: true });
      });
    }

  } // ← closes initProductDisplayTop

  initProductDisplayTop(document); // ← calls the function

})(); // ← closes and executes the IIFE